export const dashboardSteps = [
  {
    target: '[data-tour="start-consulting"]',
    title: '💬 컨설팅 시작하기',
    description: 'AI 컨설턴트와 텍스트로 대화하며 전문적인 이력서를 만들어보세요. 이미 진행 중인 컨설팅이 있다면 "컨설팅 계속하기" 버튼이 표시됩니다.',
    tip: '30분간의 자연스러운 대화로 나만의 이력서와 웹페이지를 완성할 수 있어요!'
  },
  {
    target: '[data-tour="documents-btn"]',
    title: '📄 이력서 목록',
    description: '작성했던 모든 이력서를 확인하고 관리할 수 있습니다. PDF 다운로드와 웹페이지 생성도 여기서 가능해요.',
    tip: '여러 버전의 이력서를 만들어 회사별로 맞춤 제출할 수 있습니다.'
  },
  {
    target: '[data-tour="guide-btn"]',
    title: '사용자 가이드',
    description: '더 자세한 사용법과 팁이 필요하시면 언제든 가이드를 참고하세요. 효과적인 컨설팅 방법과 웹페이지 활용법도 안내되어 있습니다.',
    tip: '컨설팅 중에 막히는 부분이 있으면 가이드의 FAQ를 확인해보세요.'
  }
];

export const consultingSteps = [
  {
    target: '[data-tour="chat-area"]',
    title: '💬 AI 컨설턴트와 대화하기',
    description: '여기서 AI 컨설턴트와 대화합니다. 자연스럽게 경력과 경험을 이야기하시면 AI가 체계적으로 질문하며 정보를 수집합니다.',
    tip: '"잘 기억이 안나요"라고 하셔도 괜찮아요. AI가 기억을 되살릴 수 있도록 도와드립니다.'
  },
  {
    target: '[data-tour="chat-input"]',
    title: '⌨️ 메시지 입력하기',
    description: '여기에 메시지를 입력해 AI 컨설턴트와 대화하세요. Enter로 전송, Shift+Enter로 줄바꿈입니다.',
    tip: '편하게 본인 경험을 풀어서 적어주세요. AI가 문맥을 파악해 이력서로 정리해드립니다.',
  },
  {
    target: '[data-tour="resume-preview"]',
    title: '📄 실시간 이력서 미리보기',
    description: '대화 내용이 실시간으로 이력서에 반영됩니다. 현재 업데이트되는 부분이 초록색으로 하이라이트됩니다.',
    tip: '확대/축소 버튼으로 이력서를 더 자세히 볼 수 있어요.'
  },
  {
    target: '[data-tour="progress-indicator"]',
    title: '진행률 확인',
    description: '현재 이력서 완성도를 퍼센트로 확인할 수 있습니다. 각 섹션별로 얼마나 채워졌는지 실시간으로 보여드려요.',
    tip: '100%가 되지 않아도 충분히 완성도 높은 이력서가 만들어집니다.'
  },
  {
    target: '[data-tour="resume-edit-btn"]',
    title: '이력서 편집하기',
    description: '언제든 이 버튼을 클릭해서 이력서를 직접 편집할 수 있습니다. AI가 놓친 부분을 보완하거나 개인적인 터치를 추가하세요.',
    tip: '편집 내용은 자동으로 저장되어 언제든 다시 수정할 수 있습니다.'
  }
];

export const resumeEditSteps = [
  {
    target: '[data-tour="edit-tabs"]',
    title: '📝 섹션별 편집',
    description: '이력서의 각 섹션을 탭으로 나누어 편집할 수 있습니다. 기본 정보, 핵심 요약, 경력, 학력, 기술, 자격증 등을 체계적으로 관리하세요.',
    tip: 'AI가 생성한 내용을 기반으로 더 구체적으로 수정하거나 누락된 정보를 추가할 수 있어요.'
  },
  {
    target: '[data-tour="pdf-download"]',
    title: '📄 PDF 다운로드',
    description: '완성된 이력서를 PDF로 다운로드할 수 있습니다. 이력서가 완성되면 버튼이 활성화되어 즉시 입사지원에 활용하세요!',
    tip: '수정할 때마다 새로운 PDF를 다운로드할 수 있으며, 한글 폰트를 포함해 깔끔하게 출력됩니다.'
  },
  {
    target: '[data-tour="portfolio-create"]',
    title: '🌐 내 웹페이지 만들기',
    description: '완성된 이력서를 바탕으로 나만의 웹페이지를 자동 생성할 수 있습니다. westory/{사용자명} URL로 접근 가능한 개인 웹페이지가 만들어집니다.',
    tip: '웹페이지는 채용담당자나 동료들과 쉽게 공유할 수 있어 이력서보다 더 역동적인 어필이 가능해요!'
  },
  {
    target: 'body',
    title: '🎉 이력서 보기 완료!',
    description: '이제 이력서 보기 기능을 모두 알아보셨습니다! 웹페이지 생성으로 온라인 프레젠스를 만들거나, AI 컨설팅을 계속해서 더 멋진 이력서를 완성해보세요.',
    tip: '이력서와 웹페이지, 두 가지 모두 활용하면 더욱 강력한 개인 브랜딩이 가능합니다!'
  }
];

export const getStepsByPage = (page) => {
  switch (page) {
    case 'dashboard':
      return dashboardSteps;
    case 'consulting':
      return consultingSteps;
    case 'resume-edit':
      return resumeEditSteps;
    default:
      return [];
  }
};

export const congratulationsStep = {
  title: '🎉 온보딩 완료!',
  description: 'Latte is의 주요 기능들을 모두 둘러보셨습니다. 이제 AI와 함께 멋진 이력서를 만들고 나만의 웹페이지까지 생성해보세요!',
  tip: '이력서 완성 후 웹페이지 생성으로 더욱 강력한 개인 브랜딩을 만들어보세요. 언제든 가이드를 참고할 수 있습니다.'
};

export const mobileOnboardingSteps = [
  {
    icon: '💬',
    title: '라떼이즈 AI와 대화로 이력서 만들기',
    description: '텍스트로 라떼이즈 AI 컨설턴트와 대화하며 전문적인 이력서를 만들어보세요.',
    tip: '라떼이즈 AI가 체계적으로 질문하며 가치있는 정보를 수집해요. 30분간의 자연스러운 대화로 완벽한 이력서가 완성됩니다!'
  },
  {
    icon: '💬',
    title: '실시간 이력서 생성',
    description: '대화 내용이 실시간으로 이력서에 반영됩니다.',
    tip: '내용이 뒤죽박죽이어도 라떼이즈 AI가 문맥을 파악하고 정리하여 정확한 이력서를 작성해줍니다.'
  },
  {
    icon: '📝',
    title: '이력서 편집하기',
    description: '생성된 이력서를 언제든 직접 편집할 수 있습니다.',
    tip: '라떼이즈 AI가 살짝 놓친 부분이 있다면 언제든지 보완하실 수 있어요. 수정 내용은 자동 저장됩니다.'
  },
  {
    icon: '📄',
    title: 'PDF 다운로드',
    description: '완성된 이력서를 PDF로 다운로드하여 바로 입사지원에 활용하세요.',
    tip: '20종의 다양한 프리미엄 이력서 템플릿이 무료로 제공됩니다.'
  },
  {
    icon: '🌐',
    title: '나만의 웹페이지 생성',
    description: '완성 된 이력서를 바탕으로 latteis/{사용자명} URL의 개인 웹페이지를 자동 생성할 수 있습니다.',
    tip: '이력서만 완성하면 3초만에 나만의 웹 페이지도 만들 수 있어요.'
  }
];